module.exports = __webpack_public_path__ + "img/cover4-1920.7eaa520d.jpg";